import Hero from '../../components/Hero'
import { Link } from 'react-router-dom'
import './HygieneServices.css'

const HygieneServices = () => {
  return (
    <>
      <Hero 
        title="Hygiene Services"
        subtitle="Essential hygiene solutions and touch-free systems to maintain clean, safe, and compliant facilities."
        backgroundImage="/services/hygiene/hygiene.png"
        height="55.78125vh"
      />
      
      <section>
        <div className="section-header">
          <h2>Hygiene Services</h2>
        </div>
        <p>We provide essential hygiene solutions to maintain clean, safe, and compliant facilities. Our range of touch-free and automated systems ensures optimal hygiene standards while reducing cross-contamination risks.</p>
        <div className="grounds-grid">
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Touch-Free Sanitary Bins</h3>
              <p>Discreet, hygienic, and hands-free sanitary disposal units designed to keep washrooms clean, compliant, and user-friendly.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Sharps &amp; Clinical Waste Bins</h3>
              <p>Secure and compliant solutions for the safe disposal of sharps and clinical waste, protecting staff and visitors.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Air Freshener Systems</h3>
              <p>Automated dispensers provide consistent fragrance, keeping washrooms and shared spaces fresh, clean, and welcoming all day.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Soap &amp; Hand Care Dispensers</h3>
              <p>Touch-free soap and sanitiser dispensers that promote hand hygiene and reduce cross-contamination risks.</p>
            </article>
          </Link>
        </div>
      </section>
      
      <section className="cta-section">
        <h2>Maintain Optimal Hygiene Standards</h2>
        <p>Our hygiene solutions help you create safer, cleaner environments for your staff and visitors. Contact us to learn how we can support your facility's hygiene needs.</p>
        <a className="cta-button" href="/contact">Enquire Now</a>
      </section>
    </>
  )
}

export default HygieneServices
